import { IS_DANONE_ENV } from './config'

export const appName = IS_DANONE_ENV ? 'Danone Admin Panel' : 'Jume Admin Panel'
export const templatePageName = 'Шаблоны'
